.cw{padding:0.5rem;}